export default __webpack_public_path__ + "static/media/close.4d9fd49d.svg";